<script setup>
  import { useProfileStore } from '@/stores/profile.store'
  import { defineEmits, onMounted, ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()
  const profileStore = useProfileStore()
  const emit = defineEmits(['changeLanguage'])
  const loaded = ref(false)
  onMounted(async() => {
    await profileStore.fetchProfile(false)
    loaded.value = true
  })
  async function change_learning_language(language) {
    await profileStore.changeLanguage(language)
    emit('changeLanguage', language)
  }
</script>
<template>
  <div class="row align-items-center justify-content-end py-1 mb-4">
    <span v-if="loaded" class="d-flex align-items-center nowrap">
      <b>{{ t('cards.currently-studying') }} : </b>
      <select class="form-select ms-2 custom-select-width" id="level" v-model="profileStore.profile.learning_language" @change="event => change_learning_language(event.target.value)">
        <option v-for="language in profileStore.profile.languages" v-bind:key="language.id" v-bind:value="language.language">
          {{ t(`language.name.${language.language_id}`) }}
        </option>
      </select>
    </span>
  </div>
</template>

<style scoped>
/* Prevent text wrapping */
.nowrap {
  white-space: nowrap;
}

/* Adjust the width of the select element */
.custom-select-width {
  width: auto;
  min-width: 150px; /* Set a reasonable minimum width */
  max-width: 300px; /* Optional: limit the maximum width */
}
</style>
